import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { LoggingService } from '../../services/logging.service';

export const authGuardCanMatch: CanMatchFn = (route, segments) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const loggingService = inject(LoggingService);

  return authService.isInitializing$.pipe(
    filter((isInitializing) => isInitializing === false),
    take(1),
    map(() => {
      if (!authService.isAuthenticated()) {
        loggingService.logException('The user is not authenticated. Redirecting to login.', 3, 'AuthGuard', { function: 'authService.isInitializing$.pipe', path: route.path });
        return router.createUrlTree(['/']);
      }

      const routeRoles = route.data?.['roles'] ?? [];

      const userRoles = authService.currentUser()?.roles ?? [];

      if (!routeRoles?.length || routeRoles.some((role: string) => userRoles.includes(role))) {
        return true;
      } else {
        return false;
      }
    }),
  );
};
